import request from '@/utils/request'

export function fetchJsApiConfig(data) {
    return request({
        url: 'api/we_chat/getJsApiConfig',
        method: 'post',
        data
    })
}